var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 2.25)",
    stroke: "#D2D2D9",
    strokeWidth: 2.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.304 106.435h25.044M0 68.87h68.87M50.087 87.652v9.391a9.391 9.391 0 0 1-9.391 9.392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.217 56.348V6.26A6.26 6.26 0 0 0 118.957 0H6.26A6.26 6.26 0 0 0 0 6.26v75.131a6.26 6.26 0 0 0 6.26 6.261h50.088"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EEF0F3",
    cx: 106.435,
    cy: 106.435,
    r: 37.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.957 106.435h-12.522V87.652"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorClock);
export default __webpack_public_path__ + "static/media/monitor-clock.cf130611d27c6a7191afa68da47b3f47.svg";
export { ForwardRef as ReactComponent };